import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Solicitacao from '../../../components/user/solicitacao/listar';


function ListSolicitacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Solicitações Respondidas | Departamento de TI" />
            <Header />
            <Solicitacao />
            <Footer />
        </Fragment>
    );
}

export default ListSolicitacaoScreen;